module.exports = __webpack_public_path__ + "static/media/DZ.3957980a.png";